import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Slideover, { SlideoverProps } from "components/Slideover";
import ThreeDotMenu from "components/ThreeDotMenu";
import { Item } from "components/PopoverMenu";
import { useTranslation } from "react-i18next";

type FullModalProps = Omit<SlideoverProps, "open" | "HeaderComponent" | "FooterComponent"> & {
  title: string;
  footer?: React.ReactNode;
  onClose?: () => void;
  menuItems?: Item[];
  extraContent?: React.ReactNode;
  editTitleComponent?: React.ReactNode;
};

const FullModal: React.FC<FullModalProps> = ({
  title,
  children,
  onClose,
  footer,
  menuItems,
  extraContent,
  editTitleComponent,
}) => {
  const [t] = useTranslation();
  return (
    <Slideover
      open
      onClose={onClose}
      HeaderComponent={
        <Grid container spacing={2} wrap="nowrap" justify="space-between">
          <Grid item>
            {Boolean(editTitleComponent) ? editTitleComponent : <Typography variant="h4">{title}</Typography>}
          </Grid>
          {menuItems && (
            <Grid item>
              <ThreeDotMenu items={menuItems} ariaLabel={t("fullModal.menuAriaLabel")} />
            </Grid>
          )}
          {extraContent && <Grid item>{extraContent}</Grid>}
        </Grid>
      }
      FooterComponent={footer}
    >
      {children}
    </Slideover>
  );
};

export default FullModal;
